import { render, staticRenderFns } from "./kd.vue?vue&type=template&id=480439f4&"
import script from "./kd.vue?vue&type=script&lang=js&"
export * from "./kd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports